export const ROLES = {
  administrator: 'administrator',
  operations: 'operations',
  client: 'client',
  consultant: 'consultant',
  superadministrator: 'superadministrator'
};

export const ROLE_LABELS = {
  [ROLES.administrator]: 'Administrator',
  [ROLES.operations]: 'Operations',
  [ROLES.client]: 'Client',
  [ROLES.consultant]: 'Consultant',
  [ROLES.superadministrator]: 'Super Administrator'
};
